export const BaseUrl = 'https://web.fajrmuttrahtrading.com/bill/';

export const DeleteBillApi = async (billId) => {
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  };
  const result = await fetch(
    `${BaseUrl}deleteBill?bill_id=${billId}`,
    requestOptions
  );
  return result.json();
};

export const UpdatePayment = async (getTake, billId) => {
  // console.log(getTake.getAllData,'sdfsd');
  const data = {
    creditAmount: getTake,
    bill_id: billId,
  };
  // console.log(data, 'new one');
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  const result = await fetch(
    `${BaseUrl}updateBillCreditAmount`,
    requestOptions,
  );
  return result.json();
};